import React, { useState } from 'react'
import PropTypes from 'prop-types'
import { withTranslationCustom } from 'lib/i18next'
import classNames from 'classnames'
import { graphql } from '@apollo/client/react/hoc'
import { flowRight } from 'lodash'
import { fetchPolicy } from 'lib/apolloFetchPolicy'

import ImageCrop from 'components/Image/ImageCrop/ImageCrop'
import Button from 'components/UI/Button'
import ImageContainer from 'components/ImageContainer'
import Icon from 'components/Icon'
import LoadingIndicator from 'components/LoadingIndicator'

import getOriginalImage from 'graphql/image/getOriginalImage.gql'

import './image-edit.pcss'

const ImageEdit = ({
    image,
    onCancel,
    onSave,
    isBlob = false,
    t,
    originalImage,
    previewName,
    mode,
    hideCropCancel = false,
}) => {
    const [isCropping, setIsCropping] = useState(mode === 'crop' || false)

    if (originalImage && originalImage.loading) return <LoadingIndicator />

    return (
        <div className="image-edit">
            <div className="image-edit__image">
                {!isCropping && (
                    <div className="image-edit__preview">
                        <ImageContainer
                            src={isBlob ? image : image.profile}
                            alt="preview"
                        />
                        <div
                            className={classNames(
                                'image-edit__crop-button-container',
                                { 'image-edit__crop-button-container--cropping': isCropping }
                            )}
                        >
                            <Button
                                className="image-edit__crop-button"
                                trackName="crop"
                                onClick={() => setIsCropping(value => !value)}
                            >
                                <Icon
                                    fa
                                    color="rgb(51, 51, 51)"
                                    style={{ backgroundColor: 'rgb(255, 255, 255, 0.5)' }}
                                    name={['far', 'crop-alt']}
                                    size="l"
                                />
                            </Button>
                        </div>
                    </div>
                )}
                {isCropping && (
                    <ImageCrop
                        isBlob={isBlob}
                        image={image}
                        onCancelCropping={() => onCancel()}
                        onCrop={(id, cropData) => onSave(id, cropData)}
                        originalImage={originalImage && originalImage.getOriginalImage}
                        previewName={previewName}
                        hideCancelButton={hideCropCancel}
                    />
                )}
            </div>
            <div className="image-edit__tools">
                {!isCropping && (
                    <div className="image-edit__actions">
                        <Button
                            className="button image-crop__done"
                            trackName="done"
                            onClick={() => onCancel()}
                        >
                            {t('common:done')}
                        </Button>
                    </div>
                )}
            </div>
        </div>
    )
}

ImageEdit.propTypes = {
    onCancel: PropTypes.func,
    onSave: PropTypes.func,
    isBlob: PropTypes.bool,
    previewName: PropTypes.string,
    mode: PropTypes.string,
    hideCropCancel: PropTypes.bool,
}

export default flowRight(
    withTranslationCustom(),
    graphql(getOriginalImage, {
        name: 'originalImage',
        options: ({ image }) => ({
            variables: {
                id: image.id,
            },
            fetchPolicy: fetchPolicy.CACHE_FIRST,
        }),
        skip: ({ isBlob }) => {
            return isBlob
        }
    }),
)(ImageEdit)
